// extracted by mini-css-extract-plugin
module.exports = {"spacer":"spacer-module--spacer--13tAc","spacerOne":"spacer-module--spacer-one--OyiU1"};